import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 1rem;
  padding: 0.6rem 1.2rem;
`;

const Label = styled.span`
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const CodeText = styled.span`
  font-size: 1.8rem;
  font-weight: bold;
  color: var(--color-white);
  letter-spacing: 0.15em;
`;

const CopyBtn = styled.button`
  background: var(--color-purple);
  border: none;
  border-radius: 0.6rem;
  padding: 0.3rem 0.8rem;
  color: var(--color-white);
  font-size: 1.2rem;
  cursor: pointer;
  transition: background 0.15s;
  font-family: inherit;

  &:hover {
    background: var(--color-dark-purple);
  }
`;

const Copied = styled.span`
  font-size: 1.2rem;
  color: #22c55e;
`;

interface Props {
  roomId: string;
}

const RoomInfo: React.FC<Props> = ({ roomId }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(roomId).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Wrapper>
      <Label>Room:</Label>
      <CodeText>{roomId}</CodeText>
      <CopyBtn onClick={handleCopy}>Copy</CopyBtn>
      {copied && <Copied>Copied!</Copied>}
    </Wrapper>
  );
};

export default RoomInfo;
